export default __webpack_public_path__ + "static/media/main_item_06.c1a51a07.png";